import React, { Component } from 'react'
import { RenderTenantList } from './utils/RenderTenantList'
import { ParseTenantInfo } from './utils/ParseTenantInfo'

export default class DigitalHouseReport extends Component {
  constructor(props) {
    super(props)

    this.requirements = {
      insideDigitalHouse: [],
      outsideDigitalHouse: [],
    }
  }

  getRequirements = () => {
    const { allTenants } = this.props

    this.requirements = {
      insideDigitalHouse: [],
      outsideDigitalHouse: [],
    }

    Object.keys(allTenants).forEach((acronym) => {
      const tenant = allTenants[acronym]

      if (tenant.partOfDigitalHouse) {
        this.requirements.insideDigitalHouse.push(ParseTenantInfo(tenant))
      } else {
        this.requirements.outsideDigitalHouse.push(ParseTenantInfo(tenant))
      }
    })
  }

  render = () => {
    const { allTenants } = this.props

    this.getRequirements()

    if (allTenants && Object.keys(allTenants).length === 0) {
      return (
        <div className="page-body__section">
          <div className="loader-container">
            <wb-spinner mode="dark" />
          </div>
        </div>
      )
    }

    return (
      <div className="page-body__section">
        <h3 className="wb-type-heading-m page-body__margin-bottom-s">
          Digital House
        </h3>

        <wb-accordion theme="light" prevent-mobile-flyout>
          <RenderTenantList
            title="Part of Digital House"
            list={this.requirements.insideDigitalHouse}
          />
          <RenderTenantList
            title="Outside of Digital House"
            list={this.requirements.outsideDigitalHouse}
          />
        </wb-accordion>
      </div>
    )
  }
}
